import { useDispatch, useSelector } from "react-redux"
import BannerHeader from "../../../Components/BannerHeader/BannerHeader"
import CustomerReview from "../../Body/CustomerReview/CutomerReview"
import Gallery from "../../Body/Gallery/Gallery"
import Footer from "../../Footer/Footer"
import PrimaryNav from "../../Header/PrimaryNav/PrimaryNav"
import { ContactUs } from "../Components/ContactUs/ContactUs"
import ServiceVideo from "../Components/ServiceVideo/ServiceVideo"
import FAQ from "../FAQ/FAQ"
import AboutForAuthors from "./AboutForAuthors/AboutForAuthors"
import classes from "./ForAuthors.module.css"
import { useEffect } from "react"
import { getAllFaq } from "../../../Store/actions/FaqAction"
import Timeline from "../Components/Timeline/Timeline"
import { urls } from "../../../Routes/Urls"
import useScrollToTop from "../../../Hooks/useScrollToTop";
import SEO from "../../../Components/SEO"
const imageVisibility = "/Assets/Images/Visibility.png"
const imagePromotion = "/Assets/Images/Promotion.png"
const imageProfile = "/Assets/Images/AuthorProfile.png"
const stepsIcon = "/Assets/Icons/customization/stepsIcon.png"
const bgImage = "Assets/Images/ServicePages/ForAuthors.png"

const steps = [
    {
      stepIcon:stepsIcon,
      title: 'Visibility',
      description:
        'Make your book available on our well-known platform to connect with a wide range of readers and collectors.',
      image: imageVisibility, // replace with image path if needed
      align: 'left',
    },
    {
      stepIcon:stepsIcon,
      title: 'Promotion',
      description:
        " Increase the exposure and sales of your book by taking advantage of our focused marketing efforts.",
      image: imagePromotion, // replace with image path if needed
      align: 'right',
    },
    {
      stepIcon:stepsIcon,
      title: 'Author Profile',
      description:
        "With a personalized author profile that highlights your accomplishments, works, and future endeavors, you may showcase your journey as an author. We are here to help you every step of the way, regardless of your level of experience as a writer or where you are in the publication process. With the help of our top-notch services, bring your book to life and allow us to assist you in telling your tale to the world.",
      image: imageProfile, // replace with image path if needed
      align: 'left',
    },
  ];

const ForAuthors = () => {
    const dispatch = useDispatch()
    const crumbs = [
        { title: "Home", path: ("/") },
        { title: "For Authors", path: urls.FORAUTHOR },
    ]

    const video = useSelector((state) => state.serviceVideo?.videos?.forAuthorvideo)
    const allFaq = useSelector(state => state.Faq.questions);

    useEffect(() => {
        getAllFaq("category","For Authors","",dispatch)
    },[])
    const scrollRef = useScrollToTop();
    return (
      <div ref={scrollRef}>
        <SEO
          canonicalUrl="https://www.rarebiblio.com/leather-bound-editions-for-authors"
          keywords={"Leather Bound Editions for Authors"}
          title={"Premium Leather Bound Editions for Authors | Customize Yours"}
          description={"Partner with Rare Biblio to create custom leather-bound editions of your book—perfect for authors who want to publish premium, timeless, and collectible works."}
          structuredData={{
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "Organization",
                "name": "Rare Biblio",
                "alternateName": "Leather Bound Editions for Authors",
                "url": "https://www.rarebiblio.com/leather-bound-editions-for-authors",
                "logo": "https://www.rarebiblio.com/Assets/Icons/logo.jpg",
                "sameAs": [
                  "https://rarebiblio.com/",
                  "https://www.facebook.com/rarebiblio/",
                  "https://x.com/Rarebiblio",
                  "https://www.instagram.com/Rarebiblio",
                  "https://www.linkedin.com/company/Rarebiblio",
                  "https://www.pinterest.com/rare_biblio/"
                ]
              },
              {
                "@type": "FAQPage",
                "mainEntity": [
                  {
                    "@type": "Question",
                    "name": "Why should authors partner with Rare Biblio?",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "Partnering with us allows authors to turn their work into a timeless masterpiece by offering premium leather-bound editions. These editions elevate the prestige of your book, ensure it lasts for generations, and provide higher earnings through increased royalties."
                    }
                  },
                  {
                    "@type": "Question",
                    "name": "How do leather-bound books help preserve my legacy as an author?",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "We offer Handcrafted leather-bound books that are durable and timeless, ensuring your book endures for generations. With high-quality craftsmanship, these editions enhance the aesthetic appeal of your work while preserving it for future readers and collectors."
                    }
                  },
                  {
                    "@type": "Question",
                    "name": "Can I earn higher royalties with a leather-bound edition?",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "Yes, leather-bound editions command a higher price point. By offering a premium version of your book, you can earn more royalties and increase your overall earnings."
                    }
                  },
                  {
                    "@type": "Question",
                    "name": "Can I offer a customized edition of my book?",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "Yes, we offer customization options such as personalized messages, unique cover designs, and special inscriptions. These custom editions create a deeper connection with your audience, making each book a cherished keepsake."
                    }
                  },
                  {
                    "@type": "Question",
                    "name": "What benefits do authors get by joining your platform?",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "We transform your manuscript into a premium handcrafted leather-bound book, fully customized to your style. Plus, we list your book on our website for free, giving it exposure to readers who appreciate unique, collectible editions."
                    }
                  },
                  {
                    "@type": "Question",
                    "name": "How can I join your platform as an author?",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "Simply fill out the contact form or email us, and our team will guide you through the easy onboarding process to get your book featured and transformed."
                    }
                  },
                  {
                    "@type": "Question",
                    "name": "Do I need to pay to join your platform as an author?",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "No, there’s no fee to join our platform. Listing your book is completely free. You’ll only be charged when you choose to have your book crafted into a custom leather-bound edition."
                    }
                  },
                  {
                    "@type": "Question",
                    "name": "Can I get a custom book design if I join?",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "Yes! Our team will work closely with you to create a fully personalized design. You’ll receive a mockup and can choose everything — from leather color and embossing to fonts and finishing details."
                    }
                  },
                  {
                    "@type": "Question",
                    "name": "Will I get support with publishing and marketing my book?",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "Yes! Our professional team will assist you with publishing and marketing your book. We’ll create a custom leather-bound edition and list it on external marketplaces to help reach a wider audience."
                    }
                  },
                  {
                    "@type": "Question",
                    "name": "Is there a minimum order requirement for authors?",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "No, there’s no minimum order quantity. We craft each book on a print-on-demand basis, so authors can order as few or as many copies as they need."
                    }
                  },
                  {
                    "@type": "Question",
                    "name": "Can I use this platform if I’ve already published my book?",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "Yes, absolutely! You can have your already-published book crafted into a custom leather-bound edition without needing to republish it through our platform. We can transform any existing manuscript into a beautifully personalized book."
                    }
                  }
                ]
              }
            ]
          }}
        />
        <PrimaryNav />
        <BannerHeader
          bgImage={bgImage}
          crumbs={crumbs}
          title={"Leather Bound Editions for Authors"}
        />

        <ServiceVideo
          title={"Writers take note!"}
          videoSrc={video}
          desc={
            "We are aware of the great deal of commitment and work you put into authoring your book. Your dedication to excellence should be reflected in the beauty and prestige with which your work is displayed. \n \n Your writing will become a timeless masterpiece with the perfect aesthetic appeal offered by our premium leather-bound editions."
          }
        />

        <AboutForAuthors />

        <div className={classes.contactUs}>
          <ContactUs category={"forAuthors"} title={"Authors, Let’s Create Together!"} />
        </div>

        <div className={classes.join}>
          <h2>Exclusive Listing on Our Site</h2>
        </div>

        <div className={classes.ThesisBindingSteps}>
          <h2 className={classes.title}></h2>
          {/* <p className={classes.subtitle}> the premier destination for bibliophiles and book lovers who appreciate the art of bookmaking. As a rare books store.
                    we specialize in following things:</p> */}
          <Timeline hideSteps={true} steps={steps} />
        </div>



        <div className={classes.join}>
          <h2>Find Out More and Begin Right Now!</h2>
          <p>
          To find out more about our offerings and partnership and how we can turn your book into a masterpiece, get in touch with us at info@rarebiblio.com.
          <br/>
          Together, let's create something extraordinary.

          </p>
        </div>


        <Gallery />

        <CustomerReview />

        <FAQ data={allFaq} />
       
        <Footer />
      </div>
    );
}

export default ForAuthors